import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaBan, FaExclamationTriangle } from 'react-icons/fa';
import AnimatedModal from './AnimatedModal';
import ModalHelp from '../../../components/ModalHelp';
import BackendErrorMessage from '../../../components/BackendErrorMessage';

interface CancelarBancaModalProps {
  banca: any;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelarBancaModal: React.FC<CancelarBancaModalProps> = ({ 
  banca, 
  onClose, 
  onConfirm 
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      toast.success('Banca cancelada com sucesso!');
      onClose();
    } catch (error) {
      console.error('Erro ao cancelar banca:', error);
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white', padding: '32px', borderRadius: '12px',
        width: '480px', maxWidth: '90vw',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '48px', height: '48px', borderRadius: '50%',
            backgroundColor: '#fef2f2', marginBottom: '12px'
          }}>
            <FaBan style={{ color: '#dc2626', fontSize: '20px' }} />
          </div>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            Cancelar Banca
        <ModalHelp text="O cancelamento desvincula todos os candidatos e muda o status para Cancelada. Esta ação não pode ser desfeita." />
          </h3>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            backgroundColor: '#fef3c7', padding: '16px', borderRadius: '8px',
            marginBottom: '16px', border: '1px solid #fbbf24',
            display: 'flex', alignItems: 'flex-start', gap: '12px'
          }}>
            <FaExclamationTriangle style={{ color: '#d97706', fontSize: '16px', marginTop: '2px' }} />
            <div style={{ fontSize: '14px', color: '#92400e' }}>
              <strong>Atenção:</strong> Esta ação cancelará definitivamente a banca por erro 
              em seu planejamento inicial.
            </div>
          </div>

          <div style={{
            backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>Banca:</strong> {banca.tipoBanca?.nome}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>Data:</strong> {banca.dataDeBanca?.data ? 
                new Date(banca.dataDeBanca.data).toLocaleDateString('pt-BR') : 'Não definida'}
            </div>
            <div>
              <strong>Status atual:</strong> {banca.status}
            </div>
          </div>

          <div style={{
            backgroundColor: '#fee2e2', padding: '16px', borderRadius: '8px',
            marginTop: '16px', border: '1px solid #fca5a5'
          }}>
            <div style={{ fontSize: '14px', color: '#991b1b' }}>
              <strong>Consequências do cancelamento:</strong>
              <ul style={{ margin: '8px 0 0 16px', padding: 0 }}>
                <li>A banca será marcada como "Cancelada"</li>
                <li>Todos os candidatos vinculados serão desvinculados</li>
                <li>Os membros da banca serão liberados</li>
                <li>A banca não poderá ser reativada</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px', border: '1px solid #d1d5db',
              backgroundColor: 'white', borderRadius: '6px',
              cursor: 'pointer', fontSize: '14px', fontWeight: '500'
            }}
            disabled={loading}
          >
            Manter Banca
          </button>
          
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '10px 20px', backgroundColor: '#dc2626',
              color: 'white', border: 'none', borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: '500',
              opacity: loading ? 0.6 : 1,
              display: 'flex', alignItems: 'center', gap: '6px'
            }}
          >
            {loading ? 'Cancelando...' : (
              <>
                <FaBan style={{ fontSize: '12px' }} />
                Confirmar Cancelamento
              </>
            )}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default CancelarBancaModal;